/**
 * Timmers' eigen menu-volgorde (uit hun GraphQL `webshopProductGroups`-boom,
 * veld `webshopSortIndex`). Onze categoriepagina's + mega-menu sorteren de
 * productgroepen hierop, zodat de indeling 1-op-1 met Timmers loopt i.p.v. op
 * aantal. GEGENEREERD door `scripts/sync-order.mjs` — niet handmatig bewerken.
 *
 * Sleutel = onze categorie-slug. Groepen die hier niet in staan (merk-buckets als
 * "Overig"/"Diversen") sorteren achteraan.
 */
export const GROEP_ORDER: Record<string, string[]> = {
  "douche-en-bad": [
    "Scharnieren",
    "Glasklemmen",
    "Knoppen & Grepen",
    "Stabilisatie",
    "Afdichtprofielen",
    "Schuif- & inloopdouche",
    "Sauna",
    "U-profielen & montageprofielen",
    "Handdoekstang",
    "Overige",
  ],
  "interieurbeglazing": [
    "Deurkader",
    "Profielen",
    "Pendeldeuren",
    "Aanslagdeuren",
    "Schuifdeuren",
    "Grepen",
    "Puien",
    "Badkamerspiegels LED & verwarming",
  ],
  "vitrine-en-meubelbeslag": [
    "Schuifruitenbeslag",
    "Glasplaatdragers",
    "Scharnieren",
    "Draaischoenen",
    "Sloten",
    "Opschuifsloten",
    "Knoppen & Grepen",
  ],
  "balustrade": [
    "Profielen",
    "Frans balkon",
    "Glasklemmen",
    "Punthouders",
    "Balusters",
    "Leuningen",
    "Montagetools",
  ],
  "glasartikelen": [
    "Glaslatten",
    "Kitten",
    "Banden en Tapes",
    "Beglazingsblokjes",
    "Morso Verstekstansen",
    "Klimmaterialen",
    "Voorzetramen",
    "Gereedschappen",
    "Spiegelbenodigdheden",
    "Glasbewerkingen",
    "Glasreiniging en oppervlakte bescherming",
  ],
  "ventilatieroosters": [
    "Standaard ventilatieroosters",
    "Geluiddempende ventilatieroosters",
    "Brandwerende ventilatieroosters",
    "Hoogbouw ventilatieroosters",
    "Roosters met screen",
  ],
};

/** Volgorde van sub-subgroepen, sleutel = `"<categorie> › <groep>"`. */
export const SUB_ORDER: Record<string, string[]> = {
  "douche-en-bad › Scharnieren": ["Estlegno", "Flamea", "Flamea Pro Mini", "Flamea+", "Flamea+ Linea", "Bellagio", "Storm", "Balena", "Flinter pro", "Marine", "Pontere+", "Synera", "B-100 serie"],
  "douche-en-bad › Glasklemmen": ["Wand-Glas", "Glas-Glas"],
  "douche-en-bad › Knoppen & Grepen": ["Dubbelzijdig", "Enkelzijdig"],
  "douche-en-bad › Stabilisatie": ["Complete stangen", "Onderdelen rond", "Onderdelen vierkant", "Hoekbeugel"],
  "douche-en-bad › Afdichtprofielen": ["Onderkant", "Zijkant", "Magneetprofielen", "Zwart", "Waterkering", "Aanslagprofiel"],
  "douche-en-bad › Schuif- & inloopdouche": ["Everyspace", "BX-5000", "Solid"],
  "douche-en-bad › Sauna": ["Scharnieren", "Grepen", "Complete sets", "Afdichtprofielen"],
  "interieurbeglazing › Deurkader": ["Complete deurkadersystemen", "Valdorpels", "Beslagsets kaderkozijnen"],
  "interieurbeglazing › Profielen": ["U-profielen", "Klikprofielen", "Klemprofielen", "Accessoires"],
  "interieurbeglazing › Pendeldeuren": ["Scharnieren", "Draaischoenen & PHP's", "Vloerveren/ deurdrangers/ kozijndorpelveren", "Sloten", "Borstelprofielen", "Accessoires"],
  "interieurbeglazing › Aanslagdeuren": ["Scharnieren", "Complete deursets", "Sloten", "Tegenslotkasten", "Deurkrukken", "Valdorpels", "Deurdrangers", "Accessoires"],
  "interieurbeglazing › Schuifdeuren": ["Schuifdeursets", "Ri-Evolution", "Muto", "E-space", "Vouwwanden", "Telescopische systemen", "Accessoires"],
  "interieurbeglazing › Grepen": ["Standaard grepen", "Maatwerk grepen", "Afsluitbare grepen", "Kom grepen"],
  "interieurbeglazing › Puien": ["Bevestigingsklemmen", "Glasverbinders & draaibeslag"],
  "interieurbeglazing › Badkamerspiegels LED & verwarming": ["LED-spiegel met verwarming", "Verwarmingselementen"],
  "vitrine-en-meubelbeslag › Schuifruitenbeslag": ["2000mm versie", "5000mm versie"],
  "balustrade › Profielen": ["Vloermontage", "Zijmontage"],
  "balustrade › Frans balkon": ["Skyforce"],
  "balustrade › Glasklemmen": ["Binnen", "Buiten"],
  "glasartikelen › Glaslatten": ["Glaslat", "Neuslat", "Opdeklat", "Ventilatielat", "Ventistone", "Aluminium profielen"],
  "glasartikelen › Kitten": ["Beglazingskit", "Acrylaatkit", "Siliconenkit", "Lijmkit", "Stopverf", "Primer & Finisher", "Toebehoren", "PU Schuimen"],
  "glasartikelen › Banden en Tapes": ["Beglazingsband", "Tape", "Afdichtingsband", "Noodbeglazingsfolie"],
  "glasartikelen › Beglazingsblokjes": ["Steun- en stelblokjes", "Brandwerende glasblokjes", "Transparante glasblokjes", "Neopreen glasblokjes"],
  "glasartikelen › Morso Verstekstansen": ["Mobiele- en Werkbank verstekmachines", "Werkplaats verstekmachines", "Originele Morso messen"],
  "glasartikelen › Klimmaterialen": ["Aluminium trappen", "Aluminium ladders", "Steigers", "Steiger onderdelen", "Valbeveiliging en diversen"],
  "glasartikelen › Voorzetramen": ["Qualiview Voorzetramen", "Woodview Voorzetramen"],
  "glasartikelen › Gereedschappen": ["Handgereedschappen", "Electrische gereedschappen", "Zaagbladen en onderdelen voor renovatietools", "Ruitenlichters", "Afstrijkspatels", "Handdruk- en accukitpistolen", "Glaszuigers", "Glas vervoeren", "Veiligheidsmiddelen", "Gasbranders"],
  "glasartikelen › Spiegelbenodigdheden": ["Spiegeltape en Spiegellijm", "Spiegelbevestigingen", "Spiegelverwarmingen"],
  "glasartikelen › Glasbewerkingen": ["Glas snijden", "Glas breken", "Boren", "Slijpen en polijsten"],
  "glasartikelen › Glasreiniging en oppervlakte bescherming": ["Invisible Shield oppervlakte bescherming", "Glasreiniging", "Foliesystemen", "Siliconen druppels"],
};

/** Volgorde van sub2-groepen, sleutel = `"<categorie> › <groep> › <subgroep>"`. */
export const SUB2_ORDER: Record<string, string[]> = {
  "glasartikelen › Gereedschappen › Zaagbladen en onderdelen voor renovatietools": ["MB aansluiting (universele aansluiting)", "MZ aansluiting (geschikt voor Supercut)", "SL, SLP en SLM (Starlock)"],
  "glasartikelen › Gereedschappen › Handdruk- en accukitpistolen": ["Handdruk kitpistolen", "Perslucht kitpistolen"],
};

const LAST = 999;

/** Timmers-rang van een productgroep binnen een categorie (lager = eerder). */
export function groepRank(category: string, groep: string): number {
  const i = GROEP_ORDER[category]?.indexOf(groep) ?? -1;
  return i === -1 ? LAST : i;
}

/** Timmers-rang van een sub-subgroep binnen `<categorie> › <groep>`. */
export function subRank(category: string, groep: string, sub: string): number {
  const i = SUB_ORDER[`${category} › ${groep}`]?.indexOf(sub) ?? -1;
  return i === -1 ? LAST : i;
}

/** Timmers-rang van een sub2-groep binnen `<categorie> › <groep> › <subgroep>`. */
export function sub2Rank(category: string, groep: string, subgroep: string, sub2: string): number {
  const i = SUB2_ORDER[`${category} › ${groep} › ${subgroep}`]?.indexOf(sub2) ?? -1;
  return i === -1 ? LAST : i;
}
